import { defineStore } from 'pinia';

export const useModalStore = defineStore('modal', {
    state () {
        return {
            isShowing: false,
            pageY: 0,
            modalType: '',
            modalObj: '',
            background: true,
            message: ''
        };
    },
    getters:{
        getIsShowing () { return this.isShowing; },
        getModalType () { return this.modalType; },
        getModalBackground () { return this.background; }
    },
    actions: {
        setModalObj (obj) {
            this.modalObj = obj;
            this.background = true;
        },
        disableWheel (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            window.scrollTo(0, this.pageY);
        },
        toggleModal (type) {
            this.modalType = type;
            this.isShowing = !this.isShowing;
            this.pageY = window.scrollY;
            this.setScrollingBehavior();
        },
        showModal (type) {
            this.modalType = type;
            this.isShowing = true;
            this.pageY = window.scrollY;
            this.setScrollingBehavior();
        },
        setModalBackground (bool) {
            this.background = bool;
        },
        hideModal () {
            this.isShowing = false;
            this.setScrollingBehavior();
        },
        setScrollingBehavior () {
            if (this.isShowing) {
                window.addEventListener('scroll', this.disableWheel);
                document.getElementById('modal-view').style.top = this.pageY + 'px';
            } else {
                window.removeEventListener('scroll', this.disableWheel);
            }
        },
        showSnack (message) {
            this.modalType = 'snack';
            this.message = message;
            this.background = false;
            this.isShowing = true;

            setTimeout(() => this.hideModal(), 2500);

        }

    }
});
